import { IKnmExclusionReason } from 'APIPackage/CatalogsModule/interfaces/IKnmExclusionReason';

import { IKnmExclusionReasonSelectOption } from '../interfaces/IKnmExclusionReasonSelectOption';

export function createKnmExclusionReasonSelectOption(reason: IKnmExclusionReason): IKnmExclusionReasonSelectOption {
  return {
    ...reason,
    label: reason.name,
    value: reason.code,
  };
}
